import PropTypes from 'prop-types';

import { themes } from '../../lib/themes';
import { CloudinaryImage } from '../CloudinaryImage';

/**
 * Render the given user avatar. Note that this component
 * expects a User.avatarV2 GraphQL type.
 *
 * @param {object} opts
 * @param {object} opts.avatar
 * @param {'facebookId'|'publicId'} opts.avatar.type
 * @param {string} opts.avatar.value - Either a facebookId or a publicId value.
 * @param {number} opts.size
 * @param {string} opts.shape
 * @param {string} opts.crop
 * @returns {JSX.Element}
 */
function AvatarImage({ avatar, size, shape, crop = 'fill', ...props }) {
  const radiusRatio = shape == 'round' ? 0.5 : 0.125;
  const borderRadius = size * radiusRatio;

  const image =
    avatar?.type === 'publicId' ? { publicId: avatar?.value } : null;

  const extendedProps = {
    ...props,
    image,
    facebookId: avatar?.type === 'facebookId' ? avatar?.value : null,
    crop,
    height: size,
    width: size,
    style: {
      borderRadius,
      height: size,
      width: size,
    },
  };
  return <CloudinaryImage {...extendedProps} />;
}

AvatarImage.propTypes = {
  theme: PropTypes.oneOf(themes),
  avatarV2: PropTypes.object,
  shape: PropTypes.oneOf(['round', 'square']),
  size: PropTypes.number,
  className: PropTypes.string,
  draggable: PropTypes.bool,
};

AvatarImage.defaultProps = {
  theme: 'waybetter',
  shape: 'square',
  size: 30,
  draggable: false,
};

export default AvatarImage;
